/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaSelectOne from 'DesignSystem/TysiaSelectOne/index'
import TysiaSelectOneArrow from 'DesignSystem/TysiaSelectOne/TysiaSelectOneArrow/index'
import TysiaSelectOneContent from 'DesignSystem/TysiaSelectOne/TysiaSelectOneContent/index'
import TysiaSelectOneInput from 'DesignSystem/TysiaSelectOne/TysiaSelectOneInput/index'
import TysiaSelectOneOptions from 'DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/index'
import TysiaSelectOnePopover from 'DesignSystem/TysiaSelectOne/TysiaSelectOnePopover/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/ActionType/Content/ActionType/Content"
  
}) {
let actionTypesValueData = fromData.useDataValue({ viewPath,
context: 'action_types',
})
let eventActionTypeValueData = fromData.useDataValue({ viewPath,
context: 'event_action',
path: 'type',
})
let automationIsIntegrationValueData = fromData.useDataValue({ viewPath,
context: 'automation',
path: 'is_integration',
})
let onChange = fromHelpers.useOnChangeActionType({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaSelectOne
  viewPath={`${viewPath}/TysiaSelectOne`}
 marginTop={0}
 marginLeft={0}
 data="action_types"
 from={actionTypesValueData}
 data="event_action.type"
 value={eventActionTypeValueData}
 onChange={onChange}
 data="automation.is_integration"
 disabled={automationIsIntegrationValueData}
>
{childProps => (
<TysiaSelectOneContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneContent`}
 width={260}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneInput
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneInput`}
/>
<TysiaSelectOneArrow
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneArrow`}
/>
<TysiaSelectOnePopover
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOnePopover`}
>
{childProps => (
<TysiaSelectOneOptions
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneOptions`}
/>
)}
</TysiaSelectOnePopover>
</React.Fragment>
)}
</TysiaSelectOneContent>
)}
</TysiaSelectOne>
{children}
</React.Fragment>)
}